export default __webpack_public_path__ + "static/media/telegram.5f80bd55.svg";